import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import account from '@/services/auth/account';
import createApiError from '@/utils/api/createError';
import { createWrappedError } from '@/utils/errors';
const PREFIX = 'services: api: workbooks:';
const API_DOMAIN = process.env.NEXT_PUBLIC_FIREBASE_FUNCTIONS_DOMAIN;
const generateDeleteError = createApiError(`${PREFIX} deleteRecord:`);
const generateUpdateError = createApiError(`${PREFIX} updateRecord:`);
const generateCreateError = createApiError(`${PREFIX} createRecord:`); // DELETE request to destroy workbook

const deleteRequest = (authToken, workbookId) => fetch(`${API_DOMAIN}/api/v0/workbooks/${workbookId}`, {
  method: 'DELETE',
  headers: {
    Authorization: `FB-JWT ${authToken}`,
    'Content-Type': 'application/json'
  }
});

export const deleteRecord = async workbookId => {
  let authToken = '';

  try {
    authToken = await account.getIdToken();
  } catch (err) {
    throw createWrappedError(`${PREFIX} deleteRecord: auth token could not be recovered`, err);
  }

  let response;

  try {
    response = await deleteRequest(authToken, workbookId);
  } catch (err) {
    throw createWrappedError(`${PREFIX} deleteRecord: request failed`, err);
  }

  let responseJson = {};

  if (response.status !== 204) {
    try {
      responseJson = await response.json();
    } catch (err) {
      throw createWrappedError(`${PREFIX} deleteRecord: failed to parse JSON`, err);
    }
  } // Throw unsuccessful request API error


  const apiError = generateDeleteError(response.status, responseJson.errors);

  if (apiError) {
    throw apiError;
  }
}; // PUT request to update an existing workbook

const putRequest = (authToken, workbookId, body) => fetch(`${API_DOMAIN}/api/v0/workbooks/${workbookId}`, {
  method: 'PUT',
  headers: {
    Authorization: `FB-JWT ${authToken}`,
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(_objectSpread({}, body))
});

const updateRecord = async (workbookId, payload) => {
  let authToken = '';

  try {
    authToken = await account.getIdToken();
  } catch (tokenErr) {
    throw Error(`${PREFIX} updateRecord: auth token could not be recovered: ${tokenErr}`);
  }

  let response;

  try {
    response = await putRequest(authToken, workbookId, payload);
  } catch (err) {
    throw Error(`${PREFIX} updateRecord: PUT request failed: ${err}`);
  }

  let responseJson = {};

  if (response.status !== 204) {
    try {
      responseJson = await response.json();
    } catch (err) {
      throw Error(`${PREFIX} updateRecord: failed to parse JSON: ${err}`);
    }
  } // Throw unsuccessful request API error


  const apiError = generateUpdateError(response.status, responseJson.errors);

  if (apiError) {
    throw apiError;
  }

  const isExpected = responseJson.data && responseJson.data.attributes;

  if (!isExpected) {
    throw Error(`${PREFIX} createRecord: unexpected response payload`);
  }

  return _objectSpread(_objectSpread({}, responseJson.data.attributes), {}, {
    id: responseJson.data.id
  });
}; // POST request to create a new workbook,
// optionally associated with a widget


const postRequest = function (authToken, body) {
  let widgetId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return fetch(`${API_DOMAIN}/api/v0/workbooks${widgetId ? `?widget=${widgetId}` : ''}`, {
    method: 'POST',
    headers: {
      Authorization: `FB-JWT ${authToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(_objectSpread({}, body))
  });
};

const createRecord = async function (payload) {
  let widgetId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let authToken = '';

  try {
    authToken = await account.getIdToken();
  } catch (tokenErr) {
    throw Error(`${PREFIX} createRecord: auth token could not be recovered: ${tokenErr}`);
  }

  let response;

  try {
    response = await postRequest(authToken, payload, widgetId);
  } catch (err) {
    throw Error(`${PREFIX} createRecord: POST request failed: ${err}`);
  }

  let responseJson = {};

  if (response.status !== 204) {
    try {
      responseJson = await response.json();
    } catch (err) {
      throw Error(`${PREFIX} createRecord: failed to parse JSON: ${err}`);
    }
  } // Throw unsuccessful request API error


  const apiError = generateCreateError(response.status, responseJson.errors);

  if (apiError) {
    throw apiError;
  }

  const isExpected = responseJson.data && responseJson.data.attributes;

  if (!isExpected) {
    throw Error(`${PREFIX} createRecord: unexpected response payload`);
  }

  return _objectSpread(_objectSpread({}, responseJson.data.attributes), {}, {
    id: responseJson.data.id
  });
};

export default {
  updateRecord,
  createRecord
};